var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseBox',{staticClass:"h-96 grid place-items-center"},[_c('LoadingSpinner',{staticClass:"text-tertiary"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }